type AuthURLs {
  email: String!
  urls: [String!]!
}

type UserExistsResponse {
  email: String!
  exists: Boolean!
}
